<template>
    <div
        id="lt-yantr"
        class="advanced-calc auto-affordability-calc-lite">
        <div class="container-width b-margin60">
            <div class="row auto-affordability-calc-lite-content">
                <div class="col-md-6 left-section">
                    <div class="advanced-calc-filter">
                        <ul class="filter-inputs two-col">
                            <li>
                                <number-input
                                    v-model="DesiredMonthlyPayment"
                                    :label="labelDesiredMonthlyPayment"
                                    @input="calculate();"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="DownPayment"
                                    :label="labelDownPayment"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="TradeInValue"
                                    :label="labelTradeInValue"
                                    :tooltip-link="tooltipTradeInValue"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="AmountOwed"
                                    :label="labelAmountOwed"
                                    :tooltip-link="tooltipAmountOwed"
                                />
                            </li>
                            <li>
                                <drop-down
                                    v-model="CreditScore"
                                    :label="labelCreditScore"
                                    :options="CreditScoreList"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="InterestRate"
                                    :label="labelInterestRate"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="2"
                                    max-value="100"
                                    @input="validateInterestRate"
                                />
                            </li>
                            <li>
                                <drop-down
                                    v-model="LoanTermInYears"
                                    :label="labelLoanTerm"
                                    :options="LoanTermInYearsList"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 calculation-section right-section">
                    <h4>You could afford a car worth:</h4>
                    <label class="homeprice">{{ currencyWholeNumber(PurchasePrice) }}</label>
                    <ul class="calc-box">
                        <li>
                            <label>Monthly Payment: <lt-label
                                :span="span"
                                :tooltip-link="tooltipMonthlyPayment"
                            /></label>
                            <h3 class="value">
                                {{ currencyWholeNumber(CalculatedMoPayment) }}
                            </h3>
                        </li>
                        <li>
                            <label>Loan Amount: <lt-label
                                :span="span"
                                :tooltip-link="tooltipLoanAmount"
                            /></label>
                            <h3 class="value">
                                {{ currencyWholeNumber(LoanAmount) }}
                            </h3>
                        </li>
                    </ul>
                    <div class="view-free-offers">
                        <button
                            class="btn btn-blue"
                            type="submit"
                            @click="redirect()">
                            {{ DestinationButtonText }}
                        </button>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="disclosureText"
                            :disclosure-tokens="disclosureTokens"
                            class="disclosures"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import LoanTermList from '~/constants/loan-term-list';
    import CreditScoreList from '~/constants/credit-score-list';
    import BaseMixin from '~/mixin/base-mixin';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import LtLabel from '~/components/lt-label.vue';
    import TokenService from '~/services/token';

    export default {
        components: {
            NumberInput,
            DropDown,
            LtLabel,
            AdvertisingDisclosures,
        },
        mixins: [BaseMixin],
        props: {
            labelDesiredMonthlyPayment: {
                default: 'Desired Monthly Payment:',
            },
            labelDownPayment: {
                default: 'Down Payment:',
            },
            labelTradeInValue: {
                default: 'Trade-In Value:',
            },
            labelAmountOwed: {
                default: 'Amnt. Owed On Trade:',
            },
            labelCreditScore: {
                default: 'Credit Score:',
            },
            labelInterestRate: {
                default: 'Interest Rate:',
            },
            labelLoanTerm: {
                default: 'Loan Term:',
            },
            desiredMonthlyPayment: {
                default: 450,
            },
            downPayment: {
                default: 6000,
            },
            tradeInValue: {
                default: 3000,
            },
            amountOwed: {
                default: 0,
            },
            interestRate: {
                default: 4,
            },
            creditScore: {
                default: '1',
            },
            loanTermInYears: {
                default: 5,
            },
            span: {
                type: String,
                default: '',
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            totalMoPayment: {
                default: 478.26,
            },
            totalPayment: {
                default: 60,
            },
            totalInterest: {
                default: 840,
            },
            tooltipAmountOwed: {
                default: 'amount-owed-on-trade',
            },
            tooltipTradeInValue: {
                default: 'net-trade-in-value',
            },
            tooltipLoanAmount: {
                default: 'loan-amount',
            },
            tooltipMonthlyPayment: {
                default: 'monthly-payment',
            },
            destinationLinkOrId: {
                default: 'LT-auto-calc',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            loanAmount: {
                default: 0,
            },
            loanAmountLabel: {
                type: String,
                default: 'Loan Amount',
            },
            interestRateToken: {
                default: '',
            },
        },
        data() {
            return {
                LoanTermInYears: this.loanTermInYears,
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.autoloanterm,
                CreditScoreList: CreditScoreList.autoloan,
                TotalPayment: this.totalPayment,
                DownPayment: this.downPayment,
                AmountOwed: this.amountOwed,
                CreditScore: this.creditScore,
                DesiredMonthlyPayment: this.desiredMonthlyPayment,
                TradeInValue: this.tradeInValue,
                TotalInterest: this.totalInterest,
                InterestRate: this.interestRate,
                InterestRateToken: this.interestRateToken,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                TotalDownPayment: 0,
                PurchasePrice: 0,
                IsSliderEvent: false,
                CalculatedMoPayment: 0,
            };
        },
        computed: {
            LoanAmount() {
                return this.CalculatedMoPayment * (1 - (1 + parseFloat(this.InterestRate) / 1200) ** -this.TotalPayment) / (parseFloat(this.InterestRate) / 1200);
            },
            getFieldValues() {
                return this.unformatFigure(this.DownPayment) + this.unformatFigure(this.TradeInValue) + this.unformatFigure(this.AmountOwed) + this.unformatFigure(this.InterestRate) + parseInt(this.LoanTermInYears, 10) + this.unformatFigure(this.DesiredMonthlyPayment) + this.unformatFigure(this.CalculatedMoPayment);
            },
        },
        watch: {
            LoanTermInYears() {
                this.TotalPayment = parseInt(this.LoanTermInYears, 10) * 12;
            },
            InterestRate() {
                this.validateInterestRate();
            },
            getFieldValues() {
                this.calculate();
            },
            DesiredMonthlyPayment() {
                this.DesiredMonthlyPayment = this.checkValue(this.unformatFigure(this.DesiredMonthlyPayment));
                this.CalculatedMoPayment = this.DesiredMonthlyPayment;
            },
            PurchasePrice() {
                this.IsSliderEvent = false;
            },
            TradeInValue() {
                this.TradeInValue = this.checkValue(this.unformatFigure(this.TradeInValue));
            },
            AmountOwed() {
                this.AmountOwed = this.checkValue(this.unformatFigure(this.AmountOwed));
            },
            DownPayment() {
                this.DownPayment = this.checkValue(this.unformatFigure(this.DownPayment));
            },
        },
        mounted() {
            let isValid = false;
            this.CalculatedMoPayment = this.DesiredMonthlyPayment;
            this.TotalPayment = parseInt(this.LoanTermInYears, 10) * 12;
            if (parseInt(this.LoanTermInYears, 10) <= 0) {
                this.LoanTermInYears = 5;
            } else {
                this.LoanTermInYearsList.forEach((year) => {
                    if (parseInt(this.LoanTermInYears, 10) === year.value) {
                        isValid = true;
                    }
                });
                if (!isValid) {
                    this.LoanTermInYears = 5;
                }
            }
            if (parseInt(this.CreditScore, 10) <= 0) {
                this.CreditScore = '1';
            } else {
                isValid = false;
                this.CreditScoreList.forEach((creditScore) => {
                    if (parseInt(this.CreditScore, 10) === creditScore.value) {
                        isValid = true;
                    }
                });
                if (!isValid) {
                    this.CreditScore = '1';
                }
            }
            TokenService.GetTokenValue(this.InterestRateToken, this.updateInitialInterestRate);
            this.calculate();
        },
        methods: {
            currencyWholeNumber(figure) {
                return figure > 0 ? Accounting.formatMoney(figure, { precision: 0 }) : 0;
            },
            calculate() {
                this.TotalDownPayment = parseFloat(this.DownPayment) + parseFloat(this.TradeInValue) - parseFloat(this.AmountOwed);
                this.TotalInterest = parseFloat(this.CalculatedMoPayment) * parseFloat(this.TotalPayment) - parseFloat(this.LoanAmount);
                this.PurchasePrice = parseFloat(this.LoanAmount) + parseFloat(this.TotalDownPayment);
            },
            validateInterestRate() {
                if (this.InterestRate <= 0) {
                    this.InterestRate = 0;
                } else if (this.InterestRate >= 100) {
                    this.InterestRate = 100;
                }
            },
            checkValue(value) {
                return value > 0 ? value : 0;
            },
            updateInitialInterestRate(rate) {
                this.InterestRate = rate === '' ? this.interestRate : rate;
                this.calculate();
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
